/**
 * TruEats Interactions JS
 * Handles: ingredient tabs, products-list tabs, nutrition accordion.
 * Vanilla JS — no jQuery. Safe alongside Vintage theme.
 * File: assets/trueats-interactions.js  |  Status: NEW
 */
(function () {
  'use strict';

  /* ── Generic tab system ────────────────────────────────────────────────── */
  function initTabs(containerSelector, tabSelector, panelSelector, activeClass) {
    var containers = document.querySelectorAll(containerSelector);
    containers.forEach(function (container) {
      var tabs   = container.querySelectorAll(tabSelector);
      var panels = container.querySelectorAll(panelSelector);

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove(activeClass); });
          panels.forEach(function (p) { p.classList.remove(activeClass); });
          tab.classList.add(activeClass);
          if (panels[i]) panels[i].classList.add(activeClass);
        });
      });
    });
  }

  /* ── Ingredients showcase tabs ─────────────────────────────────────────── */
  function initIngredientTabs() {
    var section = document.querySelector('[data-trueats-ingredients]');
    if (!section) return;

    var tabs   = section.querySelectorAll('[data-trueats-ingredient-tab]');
    var panels = section.querySelectorAll('[data-trueats-ingredient-panel]');

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-trueats-ingredient-tab');

        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        tab.classList.add('is-active');
        var targetPanel = section.querySelector('[data-trueats-ingredient-panel="' + target + '"]');
        if (targetPanel) {
          targetPanel.classList.add('is-active');
          /* Panel is now display:flex — init Swiper if first time, update if already exists */
          requestAnimationFrame(function () {
            if (window.TruEatsSliders) window.TruEatsSliders.activateIngredientPanel(targetPanel);
          });
        }
      });
    });
  }

  /* ── Products list tabs + hover preview ─────────────────────────────────── */
  function initProductListTabs() {
    initTabs(
      '[data-trueats-products-list]',
      '[data-trueats-list-tab]',
      '[data-trueats-list-panel]',
      'is-active'
    );
    initListHoverPreview();
  }

  function initListHoverPreview() {
    var sections = document.querySelectorAll('[data-trueats-products-list]');
    sections.forEach(function (section) {
      var panels = section.querySelectorAll('[data-trueats-list-panel]');
      panels.forEach(function (panel) {
        var items    = panel.querySelectorAll('[data-trueats-list-item]');
        var previews = panel.querySelectorAll('[data-preview-handle]');
        if (!items.length || !previews.length) return;

        function activatePreview(handle) {
          previews.forEach(function (p) { p.classList.remove('is-active'); });
          items.forEach(function (i) { i.classList.remove('is-hovered'); });
          var target = panel.querySelector('[data-preview-handle="' + handle + '"]');
          var item   = panel.querySelector('[data-trueats-list-item="' + handle + '"]');
          if (target) target.classList.add('is-active');
          if (item)   item.classList.add('is-hovered');
        }

        items.forEach(function (item) {
          item.addEventListener('mouseenter', function () {
            activatePreview(item.getAttribute('data-trueats-list-item'));
          });
          item.addEventListener('focus', function () {
            activatePreview(item.getAttribute('data-trueats-list-item'));
          });
        });
      });
    });
  }

  /* ── Nutrition accordion ────────────────────────────────────────────────── */
  function initAccordion() {
    var accordions = document.querySelectorAll('[data-trueats-accordion]');
    accordions.forEach(function (accordion) {
      var items = accordion.querySelectorAll('.trueats-accordion-item');
      items.forEach(function (item) {
        var trigger = item.querySelector('.trueats-accordion-item__trigger');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          var isActive = item.classList.contains('is-active');

          /* Close all items in this group */
          items.forEach(function (i) { i.classList.remove('is-active'); });

          /* Toggle the clicked one */
          if (!isActive) {
            item.classList.add('is-active');
          }
        });

        /* Keyboard: Space / Enter to toggle */
        trigger.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            trigger.click();
          }
        });
      });
    });
  }

  /* ── Boot ───────────────────────────────────────────────────────────────── */
  function init() {
    initIngredientTabs();
    initProductListTabs();
    initAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
